export default __webpack_public_path__ + "src/images/packages/zannier-hotels-sonop/b5ea81f7d06464bd74842efe4a6c10f3-3.jpg";